import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onBeforeRouteUpdate, RouteLocationNormalizedLoaded, useRoute, useRouter} from "vue-router";
import {useAccountStore} from "@/stores/accountStore";
import {onMounted, ref, watch} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogBadge from "@/shared/ui/SogBadge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShoppingCartPage',
  setup(__props) {

const _router = useRouter()
const _config = useAccountStore()

const _title = ref("");


const _shoppingCart = useShoppingCartStore();
const itemsCount = ref(_shoppingCart?.count ?? 0)
const _searchVisible = ref(false)
const _sector = ref("")

async function p_init(route: RouteLocationNormalizedLoaded) {

  const sector = route.params.sector as string;
  _sector.value = sector

  _title.value = "";
  if (sector === "purchase") {
    _title.value = "Einkauf"
    /*
        console.log("page")
        await _shoppingCart.initPurchase();
    */
  }
  if (sector === "sale") {
    _shoppingCart.initSale();
    if (_shoppingCart.currentShoppingCart.invoicePerson.Person.personName) {
      _title.value = "Verkauf an " + _shoppingCart.currentShoppingCart.invoicePerson.Person.personName
    } else {
      _title.value = "Verkauf"
    }
  }


}

watch((_shoppingCart), () => {
  itemsCount.value = _shoppingCart.count
  _searchVisible.value = _sector.value === "sale"// && _shoppingCart.currentShoppingCartId !== ""
})

onMounted(async () => {
  const route = useRoute();
  await p_init(route)
})

onBeforeRouteUpdate(async (to) => {
  const sector = to.params.sector as string;
  if (!_config.hasAction(sector)) {
    await _router.push("/")
    return
  }
  await p_init(to)
});


async function onSearch() {
  await _router.push({path: "add", query: {page: "person"}})
}



return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value,
    "flex-direction": "flex-column"
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { class: "sog-card-without-title" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, {
            "with-badge": true,
            "is-toolbar": true
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-account-search",
                tooltip: "Kunde suchen",
                onClick: onSearch
              }, null, 512), [
                [_vShow, _searchVisible.value]
              ]),
              _withDirectives(_createVNode(SogBadge, {
                value: itemsCount.value,
                "badge-style": "primary",
                "badge-type": "notification",
                overlap: "true"
              }, {
                default: _withCtx(() => [
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-cart-outline",
                    tooltip: "Einkaufswagen",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(_router).push('list')))
                  })
                ]),
                _: 1
              }, 8, ["value"]), [
                [_vShow, itemsCount.value>0]
              ]),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cart-plus",
                tooltip: "Neue Produkt hinzufügen",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ( _unref(_router).push('add')))
              }),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cart-check",
                tooltip: "Zur Kasse gehen",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(_router).push('cashpoint')))
              }, null, 512), [
                [_vShow, itemsCount.value>0]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})